import { render, staticRenderFns } from "./pdf.vue?vue&type=template&id=2c7774f2&scoped=true"
import script from "./pdf.vue?vue&type=script&lang=js"
export * from "./pdf.vue?vue&type=script&lang=js"
import style0 from "./pdf.vue?vue&type=style&index=0&id=2c7774f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7774f2",
  null
  
)

export default component.exports